import type { ThunkAction } from '../../types/app.types';
import { PUBLIC_PATH, VERSION } from '../../config';
import Axios from 'axios';
export type StatusState =
  | 'ready'
  | 'update-available'
  | 'update-required'
  | 'offline-ready'
  | 'service-worker-update'
  | 'service-worker-error';
export type StatusAction = {
  type: 'status/SET';
  status: StatusState;
};

const getStatusForVersion =
  (currentVersion: string) =>
  (latestVersion: string): StatusState => {
    const [currentMajor, currentMinor] = currentVersion.split('.').map(parseFloat);
    const [latestMajor, latestMinor] = latestVersion.split('.').map(parseFloat);

    if (latestMajor > currentMajor) {
      return 'update-required';
    } else if (latestMinor > currentMinor) {
      return 'update-available';
    } else {
      return 'ready';
    }
  };

export function setStatus(): ThunkAction<Promise<any>> {
  return function (dispatch): Promise<any> {
    return Axios.get(`${PUBLIC_PATH}version.json`, {
      withCredentials: true,
    })
      .then((res) => res.data.version)
      .then(getStatusForVersion(VERSION))
      .then((status) =>
        dispatch({
          type: 'status/SET',
          status,
        })
      )
      .catch(() =>
        dispatch({
          type: 'status/SET',
          status: 'ready',
        })
      );
  };
}
export default function StatusReducer(state: StatusState = 'ready', action: StatusAction): StatusState {
  switch (action.type) {
    case 'status/SET':
      return action.status;

    default:
      return state;
  }
}
